<template>
  <generic-modal
    :title="$t('product details')"
    icon="box alternate"
    image="/images/icons/details.png"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
    ref="modal_element"
  >
    <div class="description">
      <div class="ui items">
        <div class="item">
          <div class="ui tiny image">
            <img src="/images/icons/product.png" />
          </div>
          <div class="content">
            <a @click="goto_product" class="header">{{ product.name }}</a>
            <!-- <div class="meta">
              <span class="price">$1200</span>
              <span class="stay">1 Month</span>
            </div>-->
            <div class="description">
              <p>{{ product.description }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="ui two column grid">
        <div class="column">
          <h4 class="ui dividing header">{{ $t("inputs") }}</h4>
          <div class="ui relaxed divided list">
            <div
              class="item"
              v-for="(input, index) in product.inv_input_products"
              :key="index"
            >
              <i class="right arrow middle aligned icon"></i>
              <div class="content">
                <div>
                  {{ input.quantity }}
                  <span v-if="input.pvd_provider">
                    {{ $t("by") }}
                    <span>{{
                      input.pvd_provider ? input.pvd_provider.name : ""
                    }}</span>
                  </span>
                  {{ $t("on") }}
                  <small>{{
                    input.inv_input.create_date
                      | formatDate(enterprise_setup.second_detailed_date_format)
                  }}</small>
                </div>
                <div class="description">{{ input.inv_input.description }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <h4 class="ui dividing header">{{ $t("outputs") }}</h4>
          <div class="ui relaxed divided list">
            <div
              class="item"
              v-for="(output, index) in product.inv_output_products"
              :key="index"
            >
              <i class="left arrow middle aligned icon"></i>
              <div class="content">
                <div>
                  {{ output.quantity }} {{ $t("on") }}
                  <small>{{
                    output.inv_output.create_date
                      | formatDate(enterprise_setup.second_detailed_date_format)
                  }}</small>
                </div>
                <div class="description">
                  {{ output.inv_output.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <pre>{{ product }} </pre> -->
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast, enterprise_setup } from "@/utils";
import filters from "@/filters";
import GenericModal from "@/components/GenericModal";

export default {
  name: "InventoryOverviewProductModal",
  filters: filters,
  components: {
    GenericModal,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      product: {},
    };
  },
  props: {
    product_in: Object,
  },
  methods: {
    finished() {
      return new Promise(function(resolve) {
        resolve();
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    goto_product() {
      let vm = this;
      this.$router.push({
        name: "ProductView",
        query: { i: this.product.uuid },
      });

      window.jQuery(vm.$el).modal("hide");
    },
  },
  mounted() {
    let vm = this;
    vm.$refs.modal_element.set_loading(true);
    local_api(vm, "post", "/inventory_overview/do-get-product", {
      u: vm.product_in.uuid,
    })
      .then((p) => {
        vm.product = p;
        vm.$refs.modal_element.set_loading(false);
      })
      .catch((err) => {
        error_toast(err);
        vm.$refs.modal_element.set_loading(false);
      });
  },
  created() {},
  watch: {},
  updated: function() {},
};
</script>
